<template>
  <div class="footer paddingall">
    <div class="container">
      <div class="alllist">
        <div class="listitem" v-for="item, index in list" :key="index">
          <div class="title">{{ item.titlle }}</div>
          <div class="titleitem" v-for="item, index in item.list" :key="index" @click="skip(item)">
            {{ item.title }}
          </div>
        </div>
      </div>

      <div class="beian">备案号：豫ICP备2024042213号-2</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      actputh: '',
      list: [
        {
          titlle: '关于我们',
          list: [
            {
              title: '公司简介',
              path: '/aboutjuyi'
            },
            {
              title: '联系我们',
              path: '/contactus'
            },
            {
              title: '加入我们',
              path: '/contactus'
            },
          ]
        },
        {
          titlle: '下单指南',
          list: [
            {
              title: '文件规范',
              path: '/yinqianlook'
            },
            {
              title: '退款说明',
              path: '/yinqianlook'
            }
          ]
        },
        {
          titlle: '配送及支付',
          list: [
            {
              title: '物流配送',
              path: '/contactus'
            },
            {
              title: '支付帮助',
              path: '/contactus'
            }
          ]
        },
        {
          titlle: '帮助中心',
          list: [
            {
              title: '新手指南',
              path: '/contactus'
            },
            {
              title: '常见问题',
              path: '/contactus'
            },
            {
              title: '下载中心',
              path: '/contactus'
            },

          ]
        }
      ]
    };
  },
  created() {
    this.actputh = this.$route.path;

  },
  watch: {
    $route(to) {
      this.actputh = to.path;
    }
  },
  methods: {
    skip(item) {
      if (item.path) {
        if (this.actputh == item.path) return window.scrollTo(0, 0);
        this.$router.push(item.path);
      } else {
        this.$message.info('暂无该功能');
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.footer {
  background-color: #333333;

  .beian {
    font-size: 14px;
    display: block;
    text-align: center;
    color: #FFF;
    margin-top: 20px;
  }

  .alllist {
    display: flex;
    justify-content: space-between;


    .listitem {
      color: #FFFFFF;
      text-align: center;

      .title {
        font-size: 16px;
        padding-bottom: 14px;
      }

      .titleitem {
        font-size: 14px;
        color: #FFFFFF;
        margin-top: 8px;
        cursor: pointer;
      }
    }
  }
}
</style>